import {
  SET_PROMO_CODE,
  INVALID_PROMO_CODE,
  RESET_PROMO_CODE,
  SET_EMAIL_COUPON,
  RESET_APPLIED_STATE,
  APPLY_EMAIL_COUPON,
} from '../Types';

const initialState = {
  couponCode: '',
  totalLabel: '',
  promoDescription: '',
  plan: '',
  priceToBeCharged: '',
  hasApplied: false,
  isValid: false,
  isFlatDiscount: false,
  emailCoupon: '',
  validCouponCodeLabel: '',
  autoApplyCoupon: false,
};

export const promoCode = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case SET_PROMO_CODE:
      return { ...state, ...payload, isValid: true };
    case RESET_PROMO_CODE:
      return { ...state, ...initialState };
    case RESET_APPLIED_STATE:
      return { ...state, hasApplied: false };
    case INVALID_PROMO_CODE:
      return {
        ...state,
        isValid: false,
        hasApplied: true,
        validCouponCodeLabel: '',
        plan: '',
        priceToBeCharged: '',
        totalLabel: '',
        promoDescription: '',
        couponCode: payload.couponCode || '',
        emailCoupon: '',
      };
    case SET_EMAIL_COUPON:
      return { ...state, emailCoupon: payload || '' };
    case APPLY_EMAIL_COUPON:
      return { ...state, autoApplyCoupon: payload || false };
    default:
      return state;
  }
};
